/**
 * Generated by Kubb (https://kubb.dev/).
 * Do not edit manually.
 */

import fetch from '../../../client.ts';
import type { RequestConfig, ResponseErrorConfig } from '../../../client.ts';
import type {
  HealthControllerCheckLivenessQueryResponse,
  HealthControllerCheckLiveness503,
} from '../../types/HealthControllerCheckLiveness.ts';
import type { QueryKey, QueryClient, QueryObserverOptions, UseQueryResult } from '@tanstack/react-query';
import { healthCheckLiveness } from '../../methods/healthCheckLiveness.ts';
import { queryOptions, useQuery } from '@tanstack/react-query';

export const healthCheckLivenessQueryKey = () => [{ url: '/api/health/liveness' }] as const;

export type HealthCheckLivenessQueryKey = ReturnType<typeof healthCheckLivenessQueryKey>;

export function healthCheckLivenessQueryOptions(config: Partial<RequestConfig> & { client?: typeof fetch } = {}) {
  const queryKey = healthCheckLivenessQueryKey();
  return queryOptions<
    HealthControllerCheckLivenessQueryResponse,
    ResponseErrorConfig<HealthControllerCheckLiveness503>,
    HealthControllerCheckLivenessQueryResponse,
    typeof queryKey
  >({
    queryKey,
    queryFn: async ({ signal }) => {
      config.signal = signal;
      return healthCheckLiveness(config);
    },
  });
}

/**
 * {@link /api/health/liveness}
 */
export function useHealthCheckLiveness<
  TData = HealthControllerCheckLivenessQueryResponse,
  TQueryData = HealthControllerCheckLivenessQueryResponse,
  TQueryKey extends QueryKey = HealthCheckLivenessQueryKey,
>(
  options: {
    query?: Partial<
      QueryObserverOptions<
        HealthControllerCheckLivenessQueryResponse,
        ResponseErrorConfig<HealthControllerCheckLiveness503>,
        TData,
        TQueryData,
        TQueryKey
      >
    > & { client?: QueryClient };
    client?: Partial<RequestConfig> & { client?: typeof fetch };
  } = {},
) {
  const { query: queryConfig = {}, client: config = {} } = options ?? {};
  const { client: queryClient, ...queryOptions } = queryConfig;
  const queryKey = queryOptions?.queryKey ?? healthCheckLivenessQueryKey();

  const query = useQuery(
    {
      ...healthCheckLivenessQueryOptions(config),
      queryKey,
      ...queryOptions,
    } as unknown as QueryObserverOptions,
    queryClient,
  ) as UseQueryResult<TData, ResponseErrorConfig<HealthControllerCheckLiveness503>> & { queryKey: TQueryKey };

  query.queryKey = queryKey as TQueryKey;

  return query;
}
